import Vue from "vue"
import { MutationTree } from "vuex/types/index"

import { extractResourceIds } from "~/utils/store"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"

import { NotificationState, ShNotification, ShNotificationMeta, ShNotificationResource } from "./notification.types"

interface FilterState {
  filter: string;
  resource: string[]
}

interface NotificationMutation {
  params: RequestParameters<ShNotification, FilterState>
  data: ShNotificationResource[]
  meta: ShNotificationMeta
  isPaginating: boolean
}

const mutations: MutationTree<NotificationState> = {
  SET_NOTIFICATIONS (state, { data, meta, isPaginating }: NotificationMutation) {
    // For totalUnseenCount and page.cursor.next (for pagination)
    Vue.set(state, 'meta', meta)

    if (data && data.length <= 0) {
      return
    }

    data.forEach(notification => Vue.set(state.data, notification.id, notification))

    // isPaginating is used to determine if the request is coming from an infinite scroll
    if (isPaginating) {
      const [currentFilterKey] = Object.keys(state.filters)
      const currentFilterGroup = state.filters[currentFilterKey]
      const nextFilterGroup = [...currentFilterGroup, ...extractResourceIds(data)]
      Vue.set(state.filters, currentFilterKey, nextFilterGroup)
    } else {
      const [top] = data
      const groupId = (top.relationships.notificationGroup.data as JsonApi.RelationshipData).id
      state.filters = { [groupId]: extractResourceIds(data) }
    }
  },

  DELETE_NOTIFICATION (state, id) {
    const [topFilters] = Object.keys(state.filters)
    const nextFilters = state.filters[topFilters].filter(groupItemId => groupItemId !== id)

    Vue.set(state.filters, topFilters, nextFilters)
    Vue.delete(state.data, id)
  },

  DELETE_NOTIFICATIONS_BY_GROUP (state, groupId: string) {
    const notificationIds: string[] = state.filters[groupId]

    notificationIds.forEach(id => Vue.delete(state.data, id))

    state.filters = {}
  },

  SEEN_NOTIFICATIONS_BY_GROUP (state, groupId: string) {
    const notificationIds: string[] = state.filters[groupId]

    notificationIds.forEach(id => {
      const notification = state.data[id]
      Vue.set(state.data, id, { ...notification, attributes: { ...notification.attributes, seen: true }})
    })

    if (state.meta) {
      Vue.set(state.meta, 'totalUnseenCount', 0)
    }
  }
}

export default mutations
